// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-container {
    display: flex;
    height: 78%;
}

.navigator {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 10%;
}

.data-container {
    display: flex;
    flex-direction: column;
}

.main-fields {
    padding: 1vh 1vw;
    display: flex;
    height: 15%;
    justify-content: center;
}

.main-fields .text-field {
    flex-grow: 1;
}

.plan-form {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: stretch;
    overflow-y: auto;
}

.meta-data {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    border-bottom: 1px solid;
    margin-bottom: 1vh;
}
.meta-data .fields {
    display: flex;
    justify-content: space-between;
    width: 60%;
    padding: 1vh 0.5vw;
}

.input-output {
    display: flex;
    justify-content: space-between;
    width: 30%;
    align-items: stretch;
    padding: 0 1vw;
}

.select-button {
    padding: 1vh 1vw;
    margin: 2vh 1vw;
    width: 10vw;
    opacity: 0.3;
}

.select-button:hover {
    cursor: pointer;
}

.select-button.selected {
    opacity: 1;
    font-size: large;
}

.parts-selection{
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-grow: 1;
}

.plan-form .data {
    width: 50%;
    background-color: aliceblue;
    border: 1px solid;
    opacity: 0.3;
}

.plan-form .data.active {
    opacity: 1;
}

.plan-form .arrow {
    display: flex;
    justify-content: center;
    align-items: center;
}

.breadcrumbs-container {
    width: 90%;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
}

.add-new-step {
    width: 10%;
}

.step-name:hover {
    cursor: pointer;
}
.breadcrumb input{
    text-align: center;
    padding: 0.5vh 0.5vw;
    border: none;
    background-color: transparent;
    max-width: 10vw;
    text-align: center;
}

.breadcrumb .step-name {
    padding: 0.5vh 0.5vw;
}

.breadcrumb .step-no {
    padding: 0.5vh 0;
    font-size: large;
}
.breadcrumb .step-no:hover {
    cursor: pointer;
}
.steps-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    overflow-x: auto;
    overflow-y: auto;
    padding: 1vh 2vw;
}

.save-button {
    width: 10vw;
    display: flex;
    justify-content: center;
}

.assembly-details {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 22%;
}

.assembly-details .fields {
    display: flex;
    justify-content: space-between;
    width: 50%;
    padding-left: 1vw;
}

.assembly-details .action-buttons {
    display: flex;
    justify-content: space-between;
    width: 20%;
    padding: 1vh 1vw;
    align-items: center;
}

.plan-field {
    display: flex;
    justify-content: center;
    align-items: center;
}

.plan-field .label {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 1vw;
}

.expand-icon {
    position: absolute;
    right: 0;
}

.summary-data {
    overflow-y: hidden!important;
}

.step-row {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    min-height: 12vh;
}

.step-row.left {
    justify-content: end;
}

.step-row.reverse {
    direction: rtl;
    justify-content: start;
}

.step-no-badge {
    position: absolute;
    left: 1vw;
    border: 1px solid;
    padding: 0.2vh 0.5vw;
    background: white;
}

.plan-data {
    border-bottom: 1px solid;
}

.empty-msg {
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: large;
}

.expand-step {
    width: 60%;
    height: 60%;
    position: fixed;
    top: 10%;
    z-index: 11;
    background-color: white;
}

.expand-step-cover {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.85);
    display: flex;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/containers/Processes/Process.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;IACf,QAAQ;IACR,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".plan-container {\n    display: flex;\n    height: 78%;\n}\n\n.navigator {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 10%;\n}\n\n.data-container {\n    display: flex;\n    flex-direction: column;\n}\n\n.main-fields {\n    padding: 1vh 1vw;\n    display: flex;\n    height: 15%;\n    justify-content: center;\n}\n\n.main-fields .text-field {\n    flex-grow: 1;\n}\n\n.plan-form {\n    flex-grow: 1;\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n    overflow-y: auto;\n}\n\n.meta-data {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    border-bottom: 1px solid;\n    margin-bottom: 1vh;\n}\n.meta-data .fields {\n    display: flex;\n    justify-content: space-between;\n    width: 60%;\n    padding: 1vh 0.5vw;\n}\n\n.input-output {\n    display: flex;\n    justify-content: space-between;\n    width: 30%;\n    align-items: stretch;\n    padding: 0 1vw;\n}\n\n.select-button {\n    padding: 1vh 1vw;\n    margin: 2vh 1vw;\n    width: 10vw;\n    opacity: 0.3;\n}\n\n.select-button:hover {\n    cursor: pointer;\n}\n\n.select-button.selected {\n    opacity: 1;\n    font-size: large;\n}\n\n.parts-selection{\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    flex-grow: 1;\n}\n\n.plan-form .data {\n    width: 50%;\n    background-color: aliceblue;\n    border: 1px solid;\n    opacity: 0.3;\n}\n\n.plan-form .data.active {\n    opacity: 1;\n}\n\n.plan-form .arrow {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.breadcrumbs-container {\n    width: 90%;\n    display: flex;\n    justify-content: start;\n    flex-wrap: wrap;\n}\n\n.add-new-step {\n    width: 10%;\n}\n\n.step-name:hover {\n    cursor: pointer;\n}\n.breadcrumb input{\n    text-align: center;\n    padding: 0.5vh 0.5vw;\n    border: none;\n    background-color: transparent;\n    max-width: 10vw;\n    text-align: center;\n}\n\n.breadcrumb .step-name {\n    padding: 0.5vh 0.5vw;\n}\n\n.breadcrumb .step-no {\n    padding: 0.5vh 0;\n    font-size: large;\n}\n.breadcrumb .step-no:hover {\n    cursor: pointer;\n}\n.steps-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    overflow-x: auto;\n    overflow-y: auto;\n    padding: 1vh 2vw;\n}\n\n.save-button {\n    width: 10vw;\n    display: flex;\n    justify-content: center;\n}\n\n.assembly-details {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    height: 22%;\n}\n\n.assembly-details .fields {\n    display: flex;\n    justify-content: space-between;\n    width: 50%;\n    padding-left: 1vw;\n}\n\n.assembly-details .action-buttons {\n    display: flex;\n    justify-content: space-between;\n    width: 20%;\n    padding: 1vh 1vw;\n    align-items: center;\n}\n\n.plan-field {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.plan-field .label {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-right: 1vw;\n}\n\n.expand-icon {\n    position: absolute;\n    right: 0;\n}\n\n.summary-data {\n    overflow-y: hidden!important;\n}\n\n.step-row {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    width: 100%;\n    min-height: 12vh;\n}\n\n.step-row.left {\n    justify-content: end;\n}\n\n.step-row.reverse {\n    direction: rtl;\n    justify-content: start;\n}\n\n.step-no-badge {\n    position: absolute;\n    left: 1vw;\n    border: 1px solid;\n    padding: 0.2vh 0.5vw;\n    background: white;\n}\n\n.plan-data {\n    border-bottom: 1px solid;\n}\n\n.empty-msg {\n    width: 100%;\n    height: 80%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: large;\n}\n\n.expand-step {\n    width: 60%;\n    height: 60%;\n    position: fixed;\n    top: 10%;\n    z-index: 11;\n    background-color: white;\n}\n\n.expand-step-cover {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0,0,0,.85);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
